export default __webpack_public_path__ + "static/media/pd1.59962768.jpg";